import { render, staticRenderFns } from "./AppealReasonModal.vue?vue&type=template&id=5edbb9fe&scoped=true"
import script from "./AppealReasonModal.vue?vue&type=script&lang=js"
export * from "./AppealReasonModal.vue?vue&type=script&lang=js"
import style0 from "./AppealReasonModal.vue?vue&type=style&index=0&id=5edbb9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edbb9fe",
  null
  
)

export default component.exports